const assignmentPriceMethodList = [
  {
    id: 1,
    name: 'Actual cost'
  },
  {
    id: 2,
    name: 'Rate card'
  }
];

export default assignmentPriceMethodList;
